<template>
  <div id="UserDetails">
    <div v-if="user.loaded == true">
      <div
        v-if="message_display != false && message_content != ''"
        v-bind:class="`msg msg-${message_display}`"
      >
        <strong>{{ message_display.capitalize() }}: </strong
        >{{ message_content }}
      </div>
      <div v-if="edit_mode != true">
        <h2>{{ user.first_name }} {{ user.last_name }}</h2>
        <div class="address-warning" v-if="!isAddressComplete">
          WARNING: Your address information appears to be incomplete. Please update your
          information by clicking the "EDIT" button.
        </div>
        <p><i class="fas fa-envelope"></i> {{ user.email }}</p>
        <p><i class="fas fa-phone"></i> {{ user.phone }}</p>
        <p><i class="fas fa-map"></i> {{ user.address }}</p>
        <p v-if="String(user.address2).length > 1" />
        {{ user.address2 }}
        <p />
        <p>{{ address3 }}</p>
        <div class="button-set">
          <button
            id="pwd-reset"
            v-bind:disabled="password_reset"
            v-on:click="this.ResetPassword"
          >
            Reset Password
          </button>
          <button v-on:click="this.Edit">Edit</button>
          <button v-on:click="this.Logout" class="float-right">Logout</button>
        </div>
        <div class="button-set" id="address_confirmation">
          <div id="address_confirmed" v-if="user.address_confirmed == true">
            <h2>
              <i class="fas fa-check"></i> You Have Confirmed Your Address.
              Thanks!
            </h2>
          </div>
          <div id="address_unconfirmed" v-if="user.address_confirmed == false">
            <p>
              It is important that your mailing address be correct and confirmed
              if you have a Holographic Collectable, so that it can be
              delivered.
            </p>
            <p>
              Please doubled check your address above and Edit if necessary.
              When you are certain it is correct hit the Confirm Address button
              below. Thanks.
            </p>
            <h2>
              <i class="fas fa-exclamation-triangle"></i> Please Confirm Your
              Address.
              <button
                id="address-confirm"
                v-bind:disabled="address_confirmation_disabled"
                v-on:click="this.ConfirmAddress"
              >
                Confirm Address
              </button>
            </h2>
          </div>
        </div>
      </div>
      <div v-if="edit_mode == true">
        <h2>Edit User</h2>
        <form>
          <div class="row">
            <div class="block">
              <label><i class="fas fa-user"></i> First name (legal)</label>
              <input
                name="first_name"
                v-model="first_name"
                type="text"
                placeholder="First name (legal)"
                required="required"
                v-on:focus="ClearMessages"
              />
            </div>
            <div class="block">
              <label><i class="fas fa-user"></i> Last name (legal)</label>
              <input
                name="last_name"
                v-model="last_name"
                type="text"
                placeholder="Last name (legal)"
                required="required"
                v-on:focus="ClearMessages"
              />
            </div>
          </div>
          <div class="row">
            <div class="block">
              <label><i class="fas fa-phone"></i> Phone</label>
              <input
                v-model="phone"
                type="phone"
                required="required"
                placeholder="Phone Number"
                v-on:focus="ClearMessages"
              />
            </div>
          </div>
          <div class="row">
            <div class="block">
              <label><i class="fas fa-map"></i> Address</label>
              <input
                v-model="address"
                type="text"
                required="required"
                v-on:focus="ClearMessages"
              />
            </div>
            <div class="block">
              <label>Address 2</label>
              <input
                v-model="address2"
                type="text"
                v-on:focus="ClearMessages"
              />
            </div>
            <div class="block">
              <label>Country</label>
              <select
                name="country"
                v-model="country"
                v-on:focus="ClearMessages"
                v-on:change="selectedCountry"
                class="country-select"
              >
                <option value="">Select Country</option>
                <option
                  v-for="country in countries"
                  :key="country.TwoDigit"
                  :value="country.TwoDigit"
                >
                  {{ country.Name }}
                </option>
              </select>
            </div>
            <div class="block">
              <label>State/Province</label>
              <select
                name="state"
                v-model="state"
                v-on:focus="ClearMessages"
                :disabled="!country"
                class="country-select"
              >
                <option value="">Select State/Province</option>
                <option
                  v-for="state in countryStates"
                  :key="state.StateCode"
                  :value="state.StateCode"
                >
                  {{ state.Name }}
                </option>
              </select>
            </div>
            <div class="block">
              <label>City</label>
              <input
                v-model="city"
                type="text"
                required="required"
                v-on:focus="ClearMessages"
              />
            </div>
            <div class="block">
              <label>Zip/Postal</label>
              <input
                v-model="zip"
                type="text"
                required="required"
                v-on:focus="ClearMessages"
              />
            </div>
          </div>
          <button class="button-no" v-on:click="this.Cancel">
            <i class="fas fa-times"></i> Cancel
          </button>
          <button class="button-yes float-right" v-on:click="this.Save">
            <i class="fas fa-check"></i> Save
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CountryHelper from "../country-helper.js";

export default {
  name: "UserDetails",
  data() {
    return {
      user: window.portal.user,
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      address: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      message_display: false,
      message_content: "",
      password_reset: false,
      address_confirmation_disabled: false,
      address_confirmed: false,
      states: []
    };
  },
  mounted: function() {
    this.Load();
  },
  computed: {
    edit_mode: function() {
      return window.portal.user.edit_mode ? true : false;
    },
    countries() {
      return new CountryHelper().All;
    },
    countryStates() {
      const countryHelper = new CountryHelper(this.country);
      return countryHelper.states;
    },
    address3() {
      return `${this.user.city}, ${
        this.user.state
          ? `${this.getStateName(this.user.country, this.user.state)} (${
              this.user.state
            }), `
          : ""
      }${this.user.zip ? this.user.zip : ""}, ${
        this.user.country ? this.getCountryName(this.user.country) : ""
      }`;
    },
    isAddressComplete() {
      return (
        this.user.first_name &&
        this.user.last_name &&
        this.user.phone &&
        this.user.address &&
        this.user.country && this.user.country.length === 2 &&
        this.user.city &&
        this.user.zip
      );
    }
  },
  methods: {
    Clear() {
      window.portal.clearUser();
    },
    Logout() {
      window.portal.logout();
    },
    Edit(e) {
      if (e) {
        e.preventDefault();
      }
      this.first_name = window.portal.user.first_name;
      this.last_name = window.portal.user.last_name;
      this.email = window.portal.user.email;
      this.phone = window.portal.user.phone;
      this.address = window.portal.user.address;
      this.address2 = window.portal.user.address2;
      this.city = window.portal.user.city;
      this.state = window.portal.user.state;
      this.zip = window.portal.user.zip;
      this.country = window.portal.user.country;
      this.message_display = false;
      this.message_content = "";
      this.password_reset = false;
      window.portal.user.edit_mode = true;

      this.country = this.country ? new CountryHelper(this.country).TwoDigit : "";
    },
    Cancel(e) {
      if (e) {
        e.preventDefault();
      }
      window.portal.app.$SmoothScroll(
        document.getElementById("UserAccount"),
        200,
        function() {
          window.scrollBy({ top: -50, left: 0, behavior: "smooth" });
          window.portal.user.edit_mode = false;
        }
      );
    },
    Load() {
      axios.defaults.headers.common["X-Auth-Token"] =
        window.portal.session.token;
      axios
        .post(`${window.portal.api_server}/userportal/userinfo`, {
          confirm: window.portal.user.id.decode().encode()
        })
        .then(res => {
          if (res.data.status.success) {
            const data = res.data.data;
            window.portal.user.id = data.user_id.decode().encode();
            window.portal.user.first_name = data.first_name;
            window.portal.user.last_name = data.last_name;
            window.portal.user.email = data.email;
            window.portal.user.phone = data.phone;
            window.portal.user.address = data.address;
            window.portal.user.address2 = data.address2;
            window.portal.user.city = data.city;
            window.portal.user.state = data.state;
            // this.state = window.portal.user.state;
            // this.$set(this.user, 'state', data.state);
            window.portal.user.zip = data.zip;
            window.portal.user.country = data.country;
            window.portal.user.image =
              data.image != ""
                ? `${window.portal.api_server}${data.image}`
                : "";
            window.portal.user.address_confirmed = data.address_confirmed;
            window.portal.user.loaded = true;
            window.portal.user.edit = false;
            window.debug(res.data.data);
            window.debug("USER INFO LOADED");
          } else {
            window.portal.user.loaded = false;
            window.portal.user.edit_mode = false;
            window.debug("USER INFO NOT FOUND");
            window.debug(res.data);
            window.portal.logout();
          }
        })
        .catch(err => {
          window.portal.user.loaded = false;
          window.portal.user.edit_mode = false;
          window.debug("USER INFO FAILURE");
          window.debug(err);
          window.portal.logout();
        });
    },
    Save(e) {
      if (e) {
        e.preventDefault();
      }
      window.portal.app.$SmoothScroll(
        document.getElementById("UserAccount"),
        200,
        function() {
          window.scrollBy({ top: -50, left: 0, behavior: "smooth" });
          window.portal.user.edit_mode = false;
        }
      );
      window.portal.user.loaded = false;
      axios.defaults.headers.common["X-Auth-Token"] =
        window.portal.session.token;
      axios
        .post(`${window.portal.api_server}/userportal/userupdate`, {
          confirm: window.portal.user.id.decode().encode(),
          first_name: this.first_name,
          last_name: this.last_name,
          phone: this.phone,
          address: this.address,
          address2: this.address2,
          city: this.city,
          state: this.state,
          zip: this.zip,
          country: this.country
        })
        .then(res => {
          if (res.data.status.success) {
            const data = res.data.data;
            window.portal.user.id = data.user_id.decode().encode();
            window.portal.user.first_name = data.first_name;
            window.portal.user.last_name = data.last_name;
            window.portal.user.email = data.email;
            window.portal.user.phone = data.phone;
            window.portal.user.address = data.address;
            window.portal.user.address2 = data.address2;
            window.portal.user.city = data.city;
            window.portal.user.state = data.state || "";
            window.portal.user.zip = data.zip;
            window.portal.user.country = data.country || "CA";
            window.portal.user.image =
              data.image.length > 1
                ? `${window.portal.api_server}${data.image}`
                : "/images/user_nophoto.svg";
            window.portal.user.address_confirmed = data.address_confirmed;
            this.user.address_confirmed = false;
            this.address_confirmation_disabled = false;
            this.address_confirmed = false;
            window.debug(res.data.data);
            window.debug("USER UPDATED");
            this.DisplaySuccessMessage("User updated.");
            window.portal.user.edit_mode = false;
            window.portal.user.loaded = true;
          } else {
            window.debug("USER NOT UPDATED");
            window.debug(res.data);
            this.DisplayErrorMessage("User not updated.");
            window.portal.user.edit_mode = true;
            window.portal.user.loaded = true;
          }
        })
        .catch(err => {
          window.debug("USER UPDATE FAILURE");
          this.DisplayErrorMessage("Something went wrong while updating your user information. Please try again");
					window.portal.user.loaded = true;
          window.debug(err);
        });
    },
    DisplayErrorMessage(msg) {
      this.message_content = msg;
      this.message_display = "error";
      window.portal.app.$SmoothScroll(
        document.getElementById("UserDetails"),
        200,
        function() {
          window.scrollBy({ top: -50, left: 0, behavior: "smooth" });
        }
      );
    },
    DisplaySuccessMessage(msg) {
      this.message_content = msg;
      this.message_display = "success";
      window.portal.app.$SmoothScroll(
        document.getElementById("UserDetails"),
        200,
        function() {
          window.scrollBy({ top: -50, left: 0, behavior: "smooth" });
        }
      );
    },
    ClearMessages() {
      this.message_display = false;
      this.message_content = "";
    },
    ResetPassword() {
      this.password_reset = true;
      axios.defaults.headers.common["X-Auth-Token"] =
        window.portal.session.token;
      axios
        .post(`${window.portal.api_server}/userportal/emailresetpassword`, {
          confirm: window.portal.user.id.decode().encode()
        })
        .then(res => {
          if (res.data.status.success) {
            const data = res.data.data;
            window.portal.user.id = data.user_id.decode().encode();
            window.debug(res.data.data);
            window.debug("PASSWORD RESET EMAIL SENT");
            this.DisplaySuccessMessage(
              "Password Reset Email Sent. Please check your spam and junk folders if you don't see it."
            );
          } else {
            window.debug("PASSWORD RESET EMAIL NOT SENT");
            window.debug(res.data);
            this.DisplayErrorMessage("Password Reset Email Not Sent.");
            this.password_reset = false;
          }
        })
        .catch(err => {
          window.debug("PASSWORD RESET FAILURE");
          this.DisplayErrorMessage("Password Reset Failure.");
          window.debug(err);
          window.portal.user.loaded = false;
          window.portal.logout();
        });
    },
    ConfirmAddress(e) {
      if (e) {
        e.preventDefault();
      }
      this.address_confirmation_disabled = true;
      this.address_confirmed = true;
      axios.defaults.headers.common["X-Auth-Token"] =
        window.portal.session.token;
      axios
        .post(`${window.portal.api_server}/userportal/addressconfirm`, {
          confirm: window.portal.user.id.decode().encode()
        })
        .then(res => {
          if (res.data.status.success) {
            const data = res.data.data;
            window.portal.user.id = data.user_id.decode().encode();
            window.portal.user.address_confirmed = data.address_confirmed;
            window.debug(res.data.data);
            window.debug("USER ADDRESS CONFIRMED");
            this.DisplaySuccessMessage("User Address Confirmed.");
            this.address_confirmation_disabled = true;
            this.address_confirmed = true;
          } else {
            this.address_confirmation_disabled = false;
            this.address_confirmed = false;
            window.debug("USER ADDRESS NOT CONFIRMED");
            window.debug(res.data);
            this.DisplayErrorMessage("User Address Not Confirmed.");
          }
        })
        .catch(err => {
          window.debug("USER UPDATE FAILURE");
          this.DisplayErrorMessage("User not updated.");
          window.debug(err);
          window.portal.user.loaded = false;
          window.portal.logout();
        });
    },
    getCountryName(countryCode) {
      const country = new CountryHelper(countryCode);
      return country.Name;
    },
    getStateName(countryCode, chkVal) {
      const countryHelper = new CountryHelper(countryCode);
      return countryHelper.getStateNameByCode(chkVal);
    },
    selectedCountry() {
      const countryHelper = new CountryHelper();
      const states = countryHelper.getStatesByCountryCode(this.country);
      this.state = states.length ? states[0].StateCode : null;
    }
  }
};
</script>

<style>
#UserDetails .button-set:after {
  content: "";
  display: block;
  clear: both;
}

#address_confirmation {
  margin-top: 25px;
}

#address_confirmation h2 {
  font-size: 20px;
}

#address_confirmed h2 {
  color: #090;
}

#address_unconfirmed {
  color: #900;
  font-size: 13px;
}

@media only screen and (max-width: 800px) {
  #UserDetails .button-set {
    text-align: center;
  }

  #UserDetails .button-set .float-left,
  #UserDetails .button-set .float-right {
    float: none;
  }
}

.country-select {
  padding: 10px;
}
.address-warning {
  background-color: #900;
  color: white;
  padding: 0.5em;
  font-weight: 600;
}
</style>